// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"584":"5f241f2b","676":"93d2283d","787":"c99f4980","910":"7eb145d0"}[chunkId] + ".chunk.js";
};